import React from 'react'
import Avatar from '../../../assets/images/avatar.png'
import SectionItem from '../../../components/sectionitem/view'

const BrokerViewAdmin = () => {
  return (
    <div className="divide divide-y divide-gray-200">
      <SectionItem
        title={'Admin List'}
        value={
          <div>
            <div className="flex-1 flex items-center space-x-3">
              <div className="w-10 h-10 overflow-hidden rounded-full">
                <img
                  className="w-full h-full object-cover object-center"
                  src={Avatar}
                  alt="avatar image"
                />
              </div>
              <div className="font-normal text-sm">Morrison Floyd</div>
            </div>
          </div>
        }
      />

      <SectionItem
        title={'Admin List'}
        value={
          <div>
            <div className="flex-1 flex items-center space-x-3">
              <div className="w-10 h-10 overflow-hidden rounded-full">
                <img
                  className="w-full h-full object-cover object-center"
                  src={Avatar}
                  alt="avatar image"
                />
              </div>
              <div className="font-normal text-sm">Benice Syhills</div>
            </div>
          </div>
        }
      />
    </div>
  )
}

export default BrokerViewAdmin
